import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { useState } from 'react'
import { Badge, Button } from 'react-bootstrap'
import { Flex } from 'components/shared/flex'
import { zeroPadding } from 'utils/util'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { MeasureLedgerSearchForm } from 'entities/measure_ledger'
import { useFetchMeasureLedgersApi } from 'api/measure_ledger'
import { GlobalStateContext } from 'contexts/global_state_context'
import { NewMeasureLedgerForm } from './measure_ledger_form'
import { Pagination } from 'components/shared/pagination'

import FullCalendar, { EventContentArg } from '@fullcalendar/react'
import { DatesSetArg } from '@fullcalendar/common'
import dayGridPlugin from '@fullcalendar/daygrid' // pluginは、あとから
import interactionPlugin from '@fullcalendar/interaction' // needed for dayClick
import { ThemeContext } from 'contexts/theme_context'

type Props = {
    history: H.History
}

const MeasureLedgerPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const theme = useContext(ThemeContext)
    const searchForm = useForm<MeasureLedgerSearchForm>({ ordering: '-measure_ledger_date' })
    const query = useQuery<{ initialDate?: string }>()
    const listApi = useFetchMeasureLedgersApi(searchForm)

    useEffectSkipFirst(() => {
        globalState.setLoading(listApi.loading)
    }, [listApi.loading])
    const [arg, setArg] = useState<DatesSetArg | undefined>()

    useEffect(() => {
        searchForm.update((f) => {
            f.dateBefore = arg?.endStr.split('T')[0]
            f.dateAfter = arg?.startStr.split('T')[0]
        })
    }, [arg?.endStr, arg?.startStr])

    return (
        <>
            <ContentHeader
                headerTitle="測定作業日誌"
                left={
                    <>
                        <NewMeasureLedgerForm onComplete={() => listApi.execute()} />
                        <Button
                            onClick={() => {
                                const month = Number(zeroPadding(Number(arg?.view.title.slice(0, -1).split('年')[1]), 2))
                                const year = Number(arg?.view.title.slice(0, 4))

                                const dateAfter = `${year}-${month}-01`
                                const lastDay = new Date(year, month, 0)
                                const dateBefore = `${year}-${month}-${lastDay.getDate()}`
                                props.history.push(`/ledger/measure_ledger?dateBefore=${dateBefore}&dateAfter=${dateAfter}`)
                            }}
                        >
                            この月の日誌をすべて印刷
                        </Button>
                    </>
                }
            ></ContentHeader>
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {listApi.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                {
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        initialDate={query.initialDate ?? new Date()}
                        locale={'ja'}
                        eventClick={(arg) => {
                            const date = listApi.response.results.find((r) => `${r.id}` === `${arg.event.id}`)?.date
                            props.history.push(`/ledger/measure_ledger?dateAfter=${date}&dateBefore=${date}`)
                        }}
                        eventContent={(eventInfo: EventContentArg) => {
                            const measureLedger = listApi.response.results.find((r) => `${r.id}` === `${eventInfo.event.id}`)!
                            const isChecked = measureLedger.staffId !== null
                            const isToday =
                                eventInfo.event.start?.getDate() === new Date().getDate() && eventInfo.event.start?.getMonth() === new Date().getMonth()
                            return (
                                <Flex flexDirection="column" style={{ backgroundColor: isToday ? '#fbf6de' : '#fafafa' }}>
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            width: '100%',
                                            borderRadius: '5px',
                                            backgroundColor: `${
                                                eventInfo.event.start?.getMonth() === eventInfo.view.currentStart.getMonth() ? theme.primary : theme.gray2
                                            }`,
                                        }}
                                    >
                                        {eventInfo.event.title}
                                    </div>
                                    <Flex>
                                        <Badge bg={isChecked ? 'success' : 'danger'}>{isChecked ? '確認済' : '未確認'}</Badge>
                                        {measureLedger.note && <Badge bg={'info'}>特記事項あり</Badge>}
                                    </Flex>
                                </Flex>
                            )
                        }}
                        events={listApi.response.results.map((r) => {
                            return {
                                id: `${r.id}`,
                                title: '台帳作成済',
                                start: r.date,
                                end: r.date,
                                // display: 'block',
                                backgroundColor: '#fafafa',
                                borderColor: '#fafafa',
                            }
                        })}
                        height={700}
                        datesSet={(a) => {
                            if (a?.endStr !== arg?.endStr) {
                                setArg(a)
                            }
                        }}
                        validRange={{ start: '2022-02-01', end: new Date() }}
                    />
                }
            </ContentBody>
        </>
    )
}

export default withRouter(MeasureLedgerPage)
